import { __awaiter, __generator } from "tslib";
import { scrollableBarInnerKey, scrollButtonKey } from './';
import { Simulate } from 'react-dom/test-utils';
export var createScrollableBarInnerDriver = function (wrapper) {
    var base = wrapper.$("." + scrollableBarInnerKey);
    var driver = {
        scroll: function (scrollLeft) {
            if (scrollLeft === void 0) { scrollLeft = 100; }
            return __awaiter(void 0, void 0, void 0, function () { var _a, _b; return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (_a = Simulate).scroll;
                        return [4 /*yield*/, base.$('.scroller-children-container').getNative()];
                    case 1: return [2 /*return*/, _b.apply(_a, [_c.sent(), { target: { scrollLeft: scrollLeft } }])];
                }
            }); });
        },
        isRightButtonShown: function () { return base.$(".right-" + scrollButtonKey).hasClass('fade-in'); },
        isLeftButtonShown: function () { return base.$(".left-" + scrollButtonKey).hasClass('fade-in'); },
        clickRightButton: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, mockScroll()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, base.$(".right-" + scrollButtonKey).click()];
                }
            });
        }); },
        clickLeftButton: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, mockScroll(0)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, base.$(".left-" + scrollButtonKey).click()];
                }
            });
        }); },
        getScrollable: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.$('.scrollable').getNative()];
        }); }); },
        base: base
    };
    var mockScroll = function (left) {
        if (left === void 0) { left = 100; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, driver.getScrollable()];
                    case 1:
                        (_a.sent()).scroll = function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, driver.scroll(left)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        return [2 /*return*/];
                }
            });
        });
    };
    return driver;
};
//# sourceMappingURL=driver.js.map